import { render, staticRenderFns } from "./KSzh.vue?vue&type=template&id=78fa1e5f&scoped=true"
import script from "./KSzh.vue?vue&type=script&lang=js"
export * from "./KSzh.vue?vue&type=script&lang=js"
import style0 from "./KSzh.vue?vue&type=style&index=0&id=78fa1e5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fa1e5f",
  null
  
)

export default component.exports